import { ButtonProps } from "@material-ui/core/Button";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import * as React from "react";
import styled from "styled-components";

type Props = ButtonProps & {
  paddingLeftRight?: number;
};

const StyledButton = styled(PrimaryButton)`
  background-color: #fff;
  color: ${props => props.theme.palette.primary.main};
  border-color: ${props => props.theme.palette.primary.main};

  &:hover {
    background-color: #fff;
  }
`;

export const SecondaryButton: React.FunctionComponent<Props> = props => {
  return <StyledButton {...props}></StyledButton>;
};
